//import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
;(window as any).__buildTag = 'b20261024a';
import 'bootstrap/dist/css/bootstrap.min.css'; 
//import "bootstrap/dist/js/bootstrap.bundle.min.js";
import './assets/css/swiper-bundle.min.css';
import './App.css';
import './index.css';


import Routesx from './routes/routex';
import AuthProvider from 'react-auth-kit';
import createStore from 'react-auth-kit/createStore';
import { ToastContainer } from "react-toastify";
import "core-js/stable";
import "regenerator-runtime/runtime";
import "react-toastify/dist/ReactToastify.css";
import './assets/css/style.css';
import './assets/css/responsive.css';
import './assets/css/animation.css';
import AgeVerificationModal from './components/AgeVerificationModal';



const root = createRoot(
  document.getElementById('root') as HTMLElement
);
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.register('/sw.js')
    .then(reg => {
      console.log("Service Worker registered ✅", reg);
    })
    .catch(err => {
      console.error("Service Worker registration failed ❌", err);
    });
}


const store = createStore({
  debug: true,
  authName:'_auth',
  authType:'localstorage',
  cookieDomain: window.location.hostname,
  cookieSecure: window.location.protocol === 'https:'
 })


root.render(
  // <React.StrictMode>
     <AuthProvider store={store}>
       <AgeVerificationModal />
       <Routesx />
          <ToastContainer
        position="top-right"
        autoClose={50000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        progressClassName="toast-progress"
      />
    </AuthProvider>

    
  // </React.StrictMode>
);
